import { useRef } from "react";
import { State } from "../../client";
import { Image } from "../display";

interface Props {
  state: State<File | null>;
}

export function ImageInput({ state: [value, setValue] }: Props) {
  const input_ref = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        className="hidden"
        type="file"
        ref={input_ref}
        accept=".pdf,.doc,.docx,.txt,.jpg,.png,.jpeg,.zip"
        onChange={(e) => setValue(e.target.files![0])}
      />
      <div
        className="upload-preview"
        onClick={() => input_ref.current?.click()}
      >
        {value && <Image src={value} alt="Your uploaded image" />}
        {value && (
          <div
            className="remove"
            onClick={(e) => {
              e.stopPropagation();
              setValue(null);
            }}
          >
            &#10006;
          </div>
        )}
        {!value && <div className="upload-box">Click or drag to upload</div>}
      </div>
    </>
  );
}
